/**
 * WEB-3673, переделка 1 — ленивая загрузка модуля подтверждения показа.
 *
 * Код подтверждения (`./showConfirm`) нужен только прогретым страницам в
 * приложении (`?preload=1`), а весом первого экрана платил бы каждый
 * посетитель классической воронки (сторожа веса publicEntry.build.web1988 и
 * publicEntryWireWeight.build.web2015). Поэтому `PublicHostRouter` зовёт эту
 * загрузку только при `preload=1`, сразу при монтировании: кусок греется,
 * пока страница в фоне, к показу уже загружен.
 *
 * Загрузка одна на жизнь страницы. Сбой — одна повторная попытка и всё:
 * перезагружать страницу НЕЛЬЗЯ (шрам WEB-2618: перезагрузка после показа —
 * второй резолв), поэтому здесь не `retryImport`. Два сбоя подряд — `null`:
 * подтверждение не уйдёт, запуск не засчитан (та же допустимая потеря, что
 * у показа без сигнала).
 */
type ShowConfirmModule = typeof import('./showConfirm');

let pending: Promise<ShowConfirmModule | null> | null = null;

export function loadShowConfirm(
  importer: () => Promise<ShowConfirmModule> = () => import('./showConfirm'),
): Promise<ShowConfirmModule | null> {
  if (!pending) {
    pending = importer()
      .catch(() => importer())
      .catch(() => null);
  }
  return pending;
}

/** Только для тестов: «новая жизнь страницы». */
export function resetShowConfirmLoaderForTests(): void {
  pending = null;
}
